/**
 * <kj-reviews-link target="<radio id>"> wraps a link to the reviews tabs.
 * On click it selects the Reviews tab and scrolls the tabs into view.
 */
class KjReviewsLink extends HTMLElement {
  #onClick = (event) => {
    const radio = document.getElementById(this.getAttribute('target'));
    if (!radio) return;
    event.preventDefault();
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    radio.closest('.group\\/tabs')?.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    radio.focus({ preventScroll: true });
  };

  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }
}

if (!customElements.get('kj-reviews-link')) customElements.define('kj-reviews-link', KjReviewsLink);

// After a review is submitted the page reloads; reopen the Reviews tab so the shopper sees the confirmation.
const kjReviewForm = document.getElementById('kj-review-form');
if (kjReviewForm && (location.hash === '#kj-review-form' || new URLSearchParams(location.search).has('contact_posted') || kjReviewForm.querySelector('details[open]'))) {
  const panelRadio = document.querySelector('[id^="kj-tab-rev-"]');
  if (panelRadio) panelRadio.checked = true;
  kjReviewForm.scrollIntoView({ block: 'center' });
}
